(function() {
  'use strict';

  angular
    .module('contentPlayer.reuseStateModalCtrl', [])
    .controller('ReuseStateModalCtrl', ReuseStateModalCtrl);

  ReuseStateModalCtrl.$inject = ['$scope', 'ContentPlayerService', 'lastCompletedGrade'];

  function ReuseStateModalCtrl($scope, ContentPlayerService, lastCompletedGrade) {
    $scope.lastCompletedGrade = lastCompletedGrade;

    $scope.reuseScore = function() {
      ContentPlayerService.reuseState(function() {
        $scope.$close();
      }, function() {
        $scope.$close();
        return true;
      });
    };
  }
})();
